import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'
import { reduxForm, formValueSelector } from 'redux-form'
import DialogView from '../../../Dialogos/DialogView'
import { Dialog } from '@material-ui/core'
import EgresoCaladoQRLecturaScan from './EgresoCaladoQRLecturaScan'
import EgresoCaladoQRLecturaCamara from './EgresoCaladoQRLecturaCamara'
import ConfirmacionEgresoQR from '../../containers/egresoQR/ConfirmacionEgresoQR'
import { FORM_EGRESO_CALADO } from '../../../../config/forms'
import PantallaConfirmacion from '../../../Utils/containers/PantallaConfirmacion'

function EgresoCaladoQRLectura (props) {
  const { modeScan, egresoCaladoQR, cea, show, showConfirmacion, updateViewPantallaConfirmacion } = props
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const interval = setInterval(() => {
      if (showConfirmacion) {
        updateViewPantallaConfirmacion(false)
      }
    }, 1000)

    return () => {
      clearInterval(interval)
    }
  }, [showConfirmacion, updateViewPantallaConfirmacion])

  const handleClose = () => {
    setOpen(false)
    props.updateShowConfirmacionEgreso(false)
    props.updateCea(null)
  }

  const submitEgreso = (numero) => {
    const { change: formChange } = props
    if (!isNaN(numero) && (String(numero).length === 11)) {
      egresoCaladoQR(numero)
      setOpen(true)
    } else {
      toast.error('Número incorrecto')
    }
    formChange('numero', '')
  }

  const handleSubmit = (e) => {
    const { numero, calleDeBruto } = props
    e.preventDefault()
    if (calleDeBruto) {
      submitEgreso(numero)
      if (!props.modeScan) { props.closeEgresoQR() }
    } else {
      toast.error('Debe seleccionar la calle de bruto')
    }
  }

  const submitCamara = (numero) => {
    submitEgreso(numero)
  }

  const onSelectedCalleBruto = (calle) => {
    const { change: formChange } = props
    formChange('calleDeBruto', calle)
  }

  const egresoQR = (numero) => {
    const { calleDeBruto } = props
    if (calleDeBruto) {
      props.egresoQR(numero)
      if (!props.modeScan) { props.closeEgresoQR() }
    } else {
      toast.error('Debe seleccionar la calle de bruto')
    }
  }

  return (
    <>
      { showConfirmacion && <PantallaConfirmacion /> }

      { modeScan
        ? <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', height: '40vh', width: '90%', margin: 'auto' }}>
          <EgresoCaladoQRLecturaScan handleSubmit={handleSubmit} />
        </div>
        : (!open) ? <EgresoCaladoQRLecturaCamara handleSubmit={submitCamara} /> : <></>
      }

      { cea && show && <Dialog
        open={open}
        onClose={handleClose}
        fullScreen
      >
        <DialogView
          cancelCallback={handleClose}
          title='Confirme los datos para el egreso'
          content={<ConfirmacionEgresoQR
            cea={cea}
            egresoQR={egresoQR}
            updateShowConfirmacionEgreso={props.updateShowConfirmacionEgreso}
            updateViewPantallaConfirmacion={updateViewPantallaConfirmacion}
            updateCea={props.updateCea}
            onSelectedCalleBruto={onSelectedCalleBruto}
          />}
        />
      </Dialog>
      }

    </>
  )
}

const selector = formValueSelector(FORM_EGRESO_CALADO)

const mapStateToProps = (state) => {
  return {
    cea: state.calado.consultaCea,
    show: state.calado.showConfirmacionEgreso,
    showConfirmacion: state.calado.showPantallaConfirmacion,
    numero: selector(state, 'numero'),
    calleDeBruto: selector(state, 'calleDeBruto')
  }
}

const withReduxForm = reduxForm({
  form: FORM_EGRESO_CALADO,
  initialValues: {
    calleDeBruto: null
  }
})

const withRedux = connect(mapStateToProps, null)
export default withRedux(withReduxForm(EgresoCaladoQRLectura))
